<template>
  <router-view/>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
// lifecycle hooks
onMounted(() => {
  const navigatePath = window.location.pathname.replaceAll('/deep-link', '').replaceAll('/android/', '').replaceAll('/ios/', '').replaceAll('/desktop/', '')
  const UA = navigator.userAgent.toLowerCase();
  // const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(UA);
  if(UA.indexOf("android") > -1){
    router.push({ 
      name: 'Mobile',
      params: {
        platform:'android',
        navigatePath: decodeURIComponent(navigatePath) 
      }
    })
  }else if(UA.indexOf("iphone") > -1 || UA.indexOf("ipad") > -1){
    router.push({ 
      name: 'Mobile',
      params: {
        platform:'ios',
        navigatePath: decodeURIComponent(navigatePath) 
      }
    })
  }else{
    router.push({
      name: 'Desktop',
      params: {
        platform:'desktop',
        navigatePath: decodeURIComponent(navigatePath)
      },
    })
  }
})
</script>
<script>

</script>
<style>
@font-face {
  font-family: "SukhumvitSet";
  src: local("SukhumvitSet"),
   url(./assets/fonts/SukhumvitSet-Medium.ttf) format("truetype");
}
#app {
  font-family: SukhumvitSet !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: -8px;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
